<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Push Pending Transactions</div>
        <div>
          <bread-crumb :bread-crumbs="['Push Transactions']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <div class="">
        <v-card-text class="mt-3">
          <OverlayPageVue :showOverlay="loader" />
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="from_date"
                label="From Date"
                type="date"
                dense
                outlined
                class="rounded"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="to_date"
                type="date"
                label="To Date"
                dense
                outlined
                class="rounded"
              >
              </v-text-field>
            </v-col>
            <v-btn
              depressed
              @click="getDataByDate(true)"
              class="mr-2 mt-1"
              color="primary"
              small
              >Get Results
            </v-btn>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="mt-1"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter values."
              hide-details
              dense
              single-line
              clearable
              class="mt-2"
            ></v-text-field
          ></v-row>
        </v-card-text>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :search="search"
          :items="holdTxnlist"
          class=""
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              depressed
              color="primary"
              small
              class="text-capitalize"
              @click="openPopup(item)"
              >Push</v-btn
            >
          </template>
          <template v-slot:item.payment_id="{ item }">
            <a
              title="View Transaction Details"
              class="border-d"
              @click="viewTxn(item)"
              >{{ item.payment_id }}</a
            >
          </template>
          <template v-slot:item.log="{ item }">
            <v-btn
              depressed
              icon
              small
              class="text-capitalize"
              @click="DownloadLogs(item)"
              ><v-icon title="Download the log" class="ms-2"
                >mdi-file-download</v-icon
              ></v-btn
            >
          </template>
          <template v-slot:item.bank_receipt="{ item }">
            <v-img
              v-if="item.bank_receipt"
              class="ml-1"
              max-height="40"
              title="View bank advice"
              max-width="50"
              :src="item.bank_receipt"
              @click="handleImageViewer(item.bank_receipt, '')"
            />
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog persistent v-model="showPopup" max-width="500px">
      <OverlayPageVue :showOverlay="loader" />
      <v-card>
        <v-form>
          <v-card-title class="ma-0">
            <span>Push Transaction</span>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn depressed fab small @click="closePopup"
              ><v-icon small>mdi-close</v-icon></v-btn
            >
          </v-card-title>
          <v-divider class="ma-0 pa-0"></v-divider>
          <v-card-text class="mt-2">
            <v-form v-model="valid" ref="releaseForm">
              <v-row>
                <v-col cols="12" sm="12" md="12" class="my-0"
                  ><label class="required my-0 labelFontsize">Remarks</label>
                  <v-textarea
                    class="rounded"
                    dense
                    outlined
                    auto-grow
                    placeholder="Remarks"
                    :rules="remarksValidations"
                    v-model="remarks"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-form>

        <v-card-actions class="justify-end">
          <v-btn
            depressed
            color="primary"
            class="text-capitalize"
            small
            @click="pushtxnbyId()"
            >Push</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '350',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import imageViewer from "@/components/tools/imageViewer.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "../../../utils/OverlayPage.vue";
import paymentService from "@/services/PaymentService/paymentService.js";
import { validations } from "@/utils/validation";
export default {
  name: "Push Transactions",
  mixins: [alerts],
  data() {
    return {
      ...validations,
      showPopup: false,
      imageViewerUrl: null,
      isImageViewer: false,
      showRemarksField: false,
      selectedTxnId: "",
      remarks: "",
      valid: false,
      selectedTxn: null,
      from_date: new Date().toISOString().substr(0, 10),
      to_date: new Date().toISOString().substr(0, 10),
      search: "",
      headers: [
        { text: "Transcation number", value: "payment_id", sortable: false },
        { text: "Transcation date", value: "txn_date", sortable: false },
        { text: "Sender Name", value: "sender_name", align: "start" },
        { text: "Beneficiary name", value: "receiver_name", sortable: false },
        { text: "Payment mode", value: "payment_mode", sortable: false },
        { text: "Receiving amount", value: "amount", sortable: false },
        { text: "Declined Reason", value: "declained_reason", sortable: false },
        { text: "Log", value: "log", sortable: false },
        { text: "Bank Advice", value: "bank_receipt", sortable: false },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
        },
      ],
      holdTxnlist: [],
      release_items: [],
      validations: {
        releaseRules: [(v) => !!v || "Required"],
        remarksRules: [(v) => !!v || "Rquired"],
      },
      loader: false,
    };
  },
  components: {
    BreadCrumb,
    imageViewer,
    OverlayPageVue,
  },
  mounted() {
    const istodaytnx = JSON.parse(this.$route?.query?.istodaytnx);
    console.log(istodaytnx);
    if (istodaytnx) {
      this.getDataByDate(istodaytnx);
    } else {
      this.getDataByDate(istodaytnx);
    }
  },
  watch: {},
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 300);
    },

    async downloadExcelsheet() {
      if (this.holdTxnlist) {
        this.exportToExcel(this.headers, this.holdTxnlist, "Push_transactions");
      }
    },
    viewTxn(item) {
      this.$router.push({
        name: "Hold Details",
        query: { id: item.id, payment_id: item.payment_id, from: "push" },
      });
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url, val) {
      if (val === "showImage") {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      } else {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      }
    },
    Imageview(file) {
      const imageurl = URL.createObjectURL(file);
      this.suspectFileUrl = imageurl;
    },
    async pushtxnbyId() {
      const validate = this.$refs.releaseForm.validate();
      if (this.selectedTxnId && validate) {
        this.loader = true;
        try {
          const responseData = await paymentService.pushTrans(
            this.selectedTxnId,
            this.remarks
          );
          console.log(responseData);
          if (responseData.data.status_code === 200) {
            this.loader = false;
            this.showPopup = false;
            this.showAlertSuccess(
              `Transaction Pushed : ${responseData.data.message}`
            );
            this.getDataByDate(true);
          } else {
            this.loader = false;
            this.showPopup = false;
            this.showAlertError(
              `Transaction pushed : ${
                responseData.data.message ? responseData.data.message : "Failed"
              }`
            );
            this.getDataByDate(true);
          }
        } catch (e) {
          this.loader = false;
          this.showPopup = false;
          console.error(e);
          this.showAlertError(`Transaction pushed : Something went wrong`);
        }
      }
    },

    async DownloadLogs(item) {
      this.loader = true;
      try {
        const response = await paymentService.downloadLogsData(item.payment_id);
        if (response.data.status_code === 200) {
          this.loader = false;
          const url = response.request.responseURL;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "excel.xlsx");
          document.body.appendChild(link);
          link.click();
          this.showAlertSuccess("File is downloaded successfully");
        } else {
          this.showAlertError(`Download Failed:- ${response.data.message}`);
          this.loader = false;
        }
      } catch (error) {
        this.showAlertError(
          `Download Failed:- Something went wrong please try again later.`
        );
        console.error(error);
      }
    },

    async getDataByDate(is_today) {
      this.loader = true;
      var params;
      if (is_today) {
        params = {
          from_date: this.from_date,
          to_date: this.to_date,
        };
      } else {
        params = {};
      }
      try {
        const response = await paymentService.getPushedTxnsByDate(params);
        if (response.data.status_code === 200) {
          this.holdTxnlist = response.data.data.reverse();
          console.log("userList", this.holdTxnlist);
          this.stoploader();
        } else {
          this.holdTxnlist == [];
          this.stoploader();
        }
      } catch (error) {
        this.holdTxnlist = [];
        this.stoploader();
        console.error(error);
      }
    },

    async getpushTransactions(isTodaytxn) {
      this.loader = true;
      try {
        const response = await paymentService.getAllPushedTxns(isTodaytxn);
        if (response.data.status_code === 200) {
          this.holdTxnlist = response.data.data.reverse();
          console.log("userList", this.holdTxnlist);
          this.stoploader();
        } else {
          this.holdTxnlist == [];
          this.stoploader();
        }
      } catch (error) {
        this.holdTxnlist = [];
        this.stoploader();
        console.error(error);
      }
    },

    openPopup(item) {
      console.log(item);
      this.showPopup = true;
      this.selectedTxnId = item.payment_id;
    },
    closePopup() {
      this.showPopup = false;
      this.selectedTxnId = null;
      this.remarks = "";
      this.$refs.releaseForm.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.required:after {
  content: " *";
  color: red;
}
</style>
